import { ReactElement, useEffect, useLayoutEffect } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

/**
 * @prop onAfterLoad: You can use this event with lazy component to track loading state.
 * @prop onBeforeLoad: This is to capture loading end state
 */
type Props = {
  size?: EIconSize._16 | EIconSize._24 | EIconSize._32 | EIconSize._48;
  className?: string;
  onAfterLoad?: () => void;
  onBeforeLoad?: () => void;
  color?: string;
};

export const Loading = ({
  size,
  className = '',
  onAfterLoad,
  onBeforeLoad,
  color = 'var(--v3-primary-color)'
}: Props): ReactElement => {
  useLayoutEffect(() => onBeforeLoad?.(), []);

  useEffect(() => () => onAfterLoad?.(), []);

  return (
    <div className={`loading__container ${className}`}>
      <GlobalIcon
        lib="generic"
        name="spin"
        theme="default"
        size={size || EIconSize._32}
        color={color}
      />
    </div>
  );
};
